(function () {
  if (window.location.href.indexOf('localhost') !== -1) {
    return;
  }

  // multipass redirect
  let url;
  switch (window.location.host) {
    case 'kenshi-yonezu.myshopify.com':
    case 'shop.kenshiyonezu.jp':
      // production
      url = 'https://login.shop.kenshiyonezu.jp/multipass/auth';
      break;
    case 'staging-kenshi-yonezu.myshopify.com':
    case 'shop-stg.kenshiyonezu.jp':
    case '127.0.0.1:9292':
      // staging
      url = 'https://login.shop-stg.kenshiyonezu.jp/multipass/auth';
      break;
  }
  if (url) {
    const params = new URLSearchParams(location.search);
    const return_url = params.get('return_url') || params.get('checkout_url') || encodeURIComponent(document.referrer);
    window.location.href = url + '/?return_to=' + return_url;
  }
})();
